import {useCallback} from 'react';
import {
  setSalesTargetDisplayContent,
  setSalesTargetDisplayContentMedia,
  setSalesTargetChildDisplayContent,
  setSalesTargetDisplayContentMediaOptional,
  setSalesTargetFormData
} from '@/store/slices/salesTargetSlice';

export const useDisplayContentPersistence = (
  dispatch,
  salesTarget,
  isPrerequisiteTarget
) => {
  const persistDisplayContentMediaToRedux = useCallback(
    (displayContentMedia, displayContentMediaOptional) => {
      dispatch(setSalesTargetDisplayContentMedia(displayContentMedia));
      dispatch(
        setSalesTargetDisplayContentMediaOptional(displayContentMediaOptional)
      );
    },
    [dispatch]
  );

  const persistDisplayContentToRedux = useCallback(
    (
      displayContentFormData,
      displayPreReqContentFormData,
      displayContentMedia,
      displayContentMediaOptional
    ) => {
      if (isPrerequisiteTarget) {
        dispatch(setSalesTargetDisplayContent(displayPreReqContentFormData));
        dispatch(
          setSalesTargetChildDisplayContent(displayPreReqContentFormData.child)
        );
      } else {
        dispatch(setSalesTargetDisplayContent(displayContentFormData));
      }
      persistDisplayContentMediaToRedux(
        displayContentMedia,
        displayContentMediaOptional
      );

      // Preserve form data fields (startDate, endDate, etc.) to prevent data loss
      dispatch(setSalesTargetFormData(salesTarget.formData || salesTarget));
    },
    [
      dispatch,
      isPrerequisiteTarget,
      persistDisplayContentMediaToRedux,
      salesTarget
    ]
  );

  return {persistDisplayContentToRedux, persistDisplayContentMediaToRedux};
};
